module.exports = __webpack_public_path__ + "img/trainer_code.9867de9b.png";